module.exports = __webpack_public_path__ + "assets/img/4.1f20bc7b.png";